import { Vector2 } from "../../../common/vector2.js";

export enum StopBehavior
{
  KeepInstances,  // зупинити емітер, кінцеві інстанси доживають самі
  ClearInstances, // зупинити емітер + знищити всі інстанси одразу
  FadeInstances,  // зупинити емітер + плавно вбити всі інстанси
}

export interface IController 
{
  stop( behavior?: StopBehavior, fade_duration?: number ): void;
  setPosition( pos: Vector2 ): void;
  setTransform?( pos: Vector2, angle: number ): void;
  /** Пришвидшує анімацію на factor відносно now. */
  accelerate( factor: number, now: number ): void;
}